function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3493 -1338) translate(3060 164) translate(205 144) translate(0 970) translate(16 16) translate(0 32) translate(200) translate(12 12)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "#1976D2",
  rx: 20
}), /*#__PURE__*/React.createElement("path", {
  fill: "#90C4FF",
  d: "M16.17 30.24c.028.319-.088.638-.316.87-.222.219-.5.319-.775.319-.49 0-.967-.325-1.084-.87l-.706-3.3 2.512-1.64.37 4.62z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C6E0FF",
  d: "M14.384 24.202l-1.64 2.512-3.3-.709c-.547-.117-.873-.592-.873-1.08 0-.276.106-.551.326-.776.23-.228.547-.347.87-.317l4.617.37z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#90C4FF",
  d: "M29.713 27.594L28.705 28.6c-.35.353-.94.253-1.156-.194l-4.224-8.717 4.124-4.126L29.91 26.93c.052.239-.025.49-.198.664z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C6E0FF",
  d: "M24.437 12.557l-4.126 4.12-8.714-4.223c-.447-.217-.547-.809-.194-1.156l1.005-1.008c.173-.173.426-.248.665-.195l11.364 2.462z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F7FFF2",
  d: "M31.428 9.442c-.181 3.573-2.076 6.94-5.096 9.033l-10.425 7.644c-1.073.742-2.22 1.372-3.42 1.88-.16.07-.315.026-.415-.071-.097-.1-.139-.256-.072-.414.506-1.2 1.14-2.345 1.887-3.424l7.635-10.425c.411-.591.875-1.142 1.375-1.647 2.054-2.05 4.79-3.301 7.66-3.446.24-.01.462.08.626.242h.003c.164.167.253.39.242.628z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#90C4FF",
  d: "M13.556 27.391c-.77.77-1.636 1.44-2.598 1.998-.175.103-.444-.167-.344-.344 1.114-1.92 2.673-3.48 4.593-4.593.175-.103.444.166.344.344-.556.959-1.225 1.826-1.995 2.595z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1976D2",
  d: "M28.463 14.085c-.064-.064-.106-.156-.106-.256 0-.583-.228-1.133-.642-1.547-.414-.414-.96-.642-1.547-.642-.2 0-.361-.161-.361-.361 0-.2.16-.361.36-.361.779 0 1.507.302 2.057.852s.853 1.281.853 2.057c0 .2-.161.36-.361.36-.098.004-.186-.035-.253-.102z"
}))))))))));

var SvgIconServFlight = function SvgIconServFlight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconServFlight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-serv-flight.6b0c599d.svg";
export { ForwardRef as ReactComponent };